export const REQUEST_SINGLE_CONTACT_LIST_DETAILS =
  "REQUEST_SINGLE_CONTACT_LIST_DETAILS";
export const SET_SINGLE_CONTACT_LIST_DETAILS =
  "SET_SINGLE_CONTACT_LIST_DETAILS";
export const REVOKE_SINGLE_CONTACT_LIST_DETAILS =
  "REVOKE_SINGLE_CONTACT_LIST_DETAILS";
export const RESET_SINGLE_CONTACT_LIST_DETAILS =
  "RESET_SINGLE_CONTACT_LIST_DETAILS";

export const REQUEST_SINGLE_CONTACT_LIST_RECORDS =
  "REQUEST_SINGLE_CONTACT_LIST_RECORDS";
export const SET_SINGLE_CONTACT_LIST_RECORDS =
  "SET_SINGLE_CONTACT_LIST_RECORDS";
export const REVOKE_SINGLE_CONTACT_LIST_RECORDS =
  "REVOKE_SINGLE_CONTACT_LIST_RECORDS";
export const RESET_SINGLE_CONTACT_LIST_RECORDS =
  "RESET_SINGLE_CONTACT_LIST_RECORDS";

export const REQUEST_ADD_SINGLE_CONTACT_LIST_RECORD =
  "REQUEST_ADD_SINGLE_CONTACT_LIST_RECORD";
export const GRANT_ADD_SINGLE_CONTACT_LIST_RECORD =
  "GRANT_ADD_SINGLE_CONTACT_LIST_RECORD";
export const REVOKE_ADD_SINGLE_CONTACT_LIST_RECORD =
  "REVOKE_ADD_SINGLE_CONTACT_LIST_RECORD";
export const RESET_ADD_SINGLE_CONTACT_LIST_RECORD =
  "RESET_ADD_SINGLE_CONTACT_LIST_RECORD";

export const CHANGE_SINGLE_CONTACT_LIST_MODAL =
  "CHANGE_SINGLE_CONTACT_LIST_MODAL";

export const SET_SINGLE_CONTACT_LIST_ACTIVE_CONTACT_DISPLAY =
  "SET_SINGLE_CONTACT_LIST_ACTIVE_CONTACT_DISPLAY";
export const RESET_SINGLE_CONTACT_LIST_ACTIVE_CONTACT_DISPLAY =
  "RESET_SINGLE_CONTACT_LIST_ACTIVE_CONTACT_DISPLAY";

export const SET_SINGLE_CONTACT_LIST_ACTIVE_CONTACT_EDIT =
  "SET_SINGLE_CONTACT_LIST_ACTIVE_CONTACT_EDIT";
export const RESET_SINGLE_CONTACT_LIST_ACTIVE_CONTACT_EDIT =
  "RESET_SINGLE_CONTACT_LIST_ACTIVE_CONTACT_EDIT";

export const REQUEST_CHANGE_SINGLE_CONTACT_VERIFICATION =
  "REQUEST_CHANGE_SINGLE_CONTACT_VERIFICATION";
export const GRANT_CHANGE_SINGLE_CONTACT_VERIFICATION =
  "GRANT_CHANGE_SINGLE_CONTACT_VERIFICATION";
export const REVOKE_CHANGE_SINGLE_CONTACT_VERIFICATION =
  "REVOKE_CHANGE_SINGLE_CONTACT_VERIFICATION";
export const RESET_CHANGE_SINGLE_CONTACT_VERIFICATION =
  "RESET_CHANGE_SINGLE_CONTACT_VERIFICATION";

export const REQUEST_VIEW_CONTACT_SELECTION = "REQUEST_VIEW_CONTACT_SELECTION";
export const SET_VIEW_CONTACT_SELECTION = "SET_VIEW_CONTACT_SELECTION";
export const REVOKE_VIEW_CONTACT_SELECTION = "REVOKE_VIEW_CONTACT_SELECTION";
export const RESET_VIEW_CONTACT_SELECTION = "RESET_VIEW_CONTACT_SELECTION";

export const REQUEST_UPDATE_CONTACT_SELECTION =
  "REQUEST_UPDATE_CONTACT_SELECTION";
export const GRANT_UPDATE_CONTACT_SELECTION = "GRANT_UPDATE_CONTACT_SELECTION";
export const REVOKE_UPDATE_CONTACT_SELECTION =
  "REVOKE_UPDATE_CONTACT_SELECTION";
export const RESET_UPDATE_CONTACT_SELECTION = "RESET_UPDATE_CONTACT_SELECTION";

export const APPEND_CONTACTS_DELETION_ARRAY = "APPEND_CONTACTS_DELETION_ARRAY";
export const SUBTRACT_CONTACTS_DELETION_ARRAY =
  "SUBTRACT_CONTACTS_DELETION_ARRAY";

export const SET_ACTIVE_CONTACT_DELETION = "SET_ACTIVE_CONTACT_DELETION";
export const RESET_ACTIVE_CONTACT_DELETION = "RESET_ACTIVE_CONTACT_DELETION";

export const REQUEST_DELETE_SINGLE_CONTACT_LIST_ARRAY =
  "REQUEST_DELETE_SINGLE_CONTACT_LIST_ARRAY";
export const REVOKE_DELETE_SINGLE_CONTACT_LIST_ARRAY =
  "REVOKE_DELETE_SINGLE_CONTACT_LIST_ARRAY";
export const RESET_DELETE_SINGLE_CONTACT_LIST_ARRAY =
  "RESET_DELETE_SINGLE_CONTACT_LIST_ARRAY";
export const GRANT_DELETE_SINGLE_CONTACT_LIST_ARRAY =
  "GRANT_DELETE_SINGLE_CONTACT_LIST_ARRAY";

export const REQUEST_DELETE_SINGLE_CONTACT = "REQUEST_DELETE_SINGLE_CONTACT";
export const REVOKE_DELETE_SINGLE_CONTACT = "REVOKE_DELETE_SINGLE_CONTACT";
export const RESET_DELETE_SINGLE_CONTACT = "RESET_DELETE_SINGLE_CONTACT";
export const GRANT_DELETE_SINGLE_CONTACT = "GRANT_DELETE_SINGLE_CONTACT";

export const REQUEST_UPLOAD_SINGLE_CSV_FILE = "REQUEST_UPLOAD_SINGLE_CSV_FILE";
export const REVOKE_UPLOAD_SINGLE_CSV_FILE = "REVOKE_UPLOAD_SINGLE_CSV_FILE";
export const RESET_UPLOAD_SINGLE_CSV_FILE = "RESET_UPLOAD_SINGLE_CSV_FILE";
export const GRANT_UPLOAD_SINGLE_CSV_FILE = "GRANT_UPLOAD_SINGLE_CSV_FILE";

export const APPEND_CSV_FIELD_OVERRIDES_ARRAY =
  "APPEND_CSV_FIELD_OVERRIDES_ARRAY";
export const SUBTRACT_CSV_FIELD_OVERRIDES_ARRAY =
  "SUBTRACT_CSV_FIELD_OVERRIDES_ARRAY";
